import { Modal } from 'antd';

/**
 * Shows a modal informing that the patient is busy in one or more exams
 * @param {string} infoExams - Info message with format "Patient is occupied in exams: exam1||exam2||..."
 * @param {function} forceOccupiedCall - Callback to execute when the user confirms calling the patient
 * @param {function} t - Translation function from useTranslation hook
 */
export const showOccupiedPatientModal = (infoExams, forceOccupiedCall, t) => {
  const exams =
    infoExams
      .split(/occupied in exams?:/)[1]
      ?.trim()
      .split(',')
      .map((exam) => exam.trim()) || [];

  const modalTitle = exams.length > 1 
  ? `${t('examPage.examTabs.patientOccupiedInExams')}: `
  : `${t('examPage.examTabs.patientOccupiedInExam')}: `;

  const modalContent = (
    <div>
      <ul className="pl-20 mb-15 mt-10">
        {exams.map((exam, index) => (
          <li key={index} className="mb-5">
            {exam}
          </li>
        ))}
      </ul>
      <p className="mb-0" style={{ fontWeight: 500 }}>
        {t('examPage.examTabs.callPatientAnyway')}
      </p>
    </div>
  );

  Modal.confirm({
    title: modalTitle,
    content: modalContent,
    okText: 'Llamar',
    cancelText: 'Cancelar',
    centered: true,
    width: 500,
    onOk: forceOccupiedCall,
  });
};

export default showOccupiedPatientModal;